import { render, staticRenderFns } from "./MainSubCategorySearchForm.vue?vue&type=template&id=473ef5fd"
import script from "./MainSubCategorySearchForm.vue?vue&type=script&lang=ts"
export * from "./MainSubCategorySearchForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports